import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Empathy Exercise 1',
  slug: 'empathy-exercise-1',
  category: 'Empathy Exercise 1',
  date: '2025-05-16',
  image: '',
  excerpt: 'Put yourself in someone else\'s shoes',
  body: `Put yourself in someone else's shoes

It's easy to give into frustration with people in our lives: our spouse or significant other, our children, our boss or employees, our friends, our fellow travelers in traffic.

Here's an exercise that might help you feel a little charity toward them, and so be a better version of yourself when interacting with them.

Put yourself in the shoes of the person. Visualize what their life is like. Their internal world. Their sense of time. Their values. Understand that it may not be like yours. The point is empathy. So that you can really understand the world that they live in to the best of your ability.

Now, try the offshoot of the golden rule: treat them how THEY would want to be treated. See how it changes your relationship.`,
}

export default post
